import React, { Component } from "react";
import numeral from "numeral";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import {
  Card,
  CardAreaMain,
  CardContent,
  CardActions,
  CircleProgress
} from "reactackle";
import { setUiFlag } from "../../../../store/actions";

import moment from "moment";
import SelectDropdown from "../FieldsComponents/SelectDropdown/SelectDropdown";
import DateDropdown from "../FieldsComponents/DateDropdown/DateDropdown";

class InventoryGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        path: "",
        payload: {
          orderStatus: "ALL EXCEPT CANCELLED",
          toDate: moment()
            .format("DD-MM-YYYY")
            .toString(),
          fromDate: moment()
            .subtract(365, "days")
            .format("DD-MM-YYYY")
            .toString(),
          invToDate: moment()
            .format("DD-MM-YYYY")
            .toString(),
          invFromDate: "13-08-2020",
          indOrders: "NO",
          groupBy: "MONTHLY",
          days: "ALL"
        }
      }
    };
  }

  getCellValue = (strFormat, jsonValue, type) => {
    if (typeof jsonValue !== "object") {
      if (strFormat && strFormat === "numeral") {
        return <td align="right">{numeral(jsonValue).format("0,0.00")}</td>;
      } else {
        return jsonValue;
      }
    } else {
      //console.log("this is an object " + JSON.stringify(jsonValue));
      //let amt = "SGD " + numeral(props.quoteAmount).format("0,0.00");

      return JSON.stringify(jsonValue);
    }
  };

  getDivCellValue = (strFormat, jsonValue, type) => {
    if (typeof jsonValue !== "object") {
      if (strFormat && strFormat === "numeral") {
        return numeral(jsonValue).format("0,0.00");
      } else {
        return jsonValue;
      }
    } else {
      //console.log(type + " this is an object " + JSON.stringify(jsonValue));
      //let amt = "SGD " + numeral(props.quoteAmount).format("0,0.00");
      if (type === "photoUpload") {
        return <div className="images">{this.getImages(jsonValue)}</div>;
      } else {
        return JSON.stringify(jsonValue);
      }
    }
  };

  getColumns = (jObject, tableDef) => {
    //console.log(JSON.stringify(this.state))
    //console.log(JSON.stringify(tableDef));

    return Object.keys(tableDef).map((key, index) => {
      //console.log(key + "=" + tableDef[key]);
      if (key !== "searches") {
        if (index === 0) {
          return (
            <td
              data-title={tableDef[key].caption}
              style={{
                wordBreak: "break-word",
                wordWrap: "break-word",
                overflowWrap: "break-word"
              }}
            >
              <a
                href="#"
                onClick={() =>
                  this.props.handleEdit(
                    jObject.key,
                    this.props.tableName,
                    jObject
                  )
                }
              >
                {this.getCellValue(
                  tableDef[key].format,
                  jObject[key],
                  tableDef[key].type
                )}
              </a>
            </td>
          );
        } else {
          return (
            <td
              data-title={tableDef[key].caption}
              style={{
                wordBreak: "break-word",
                wordWrap: "break-word",
                overflowWrap: "break-word"
              }}
            >
              {this.getCellValue(
                tableDef[key].format,
                jObject[key],
                tableDef[key].type
              )}
            </td>
          );
        }
      }
    });
  };

  getDivColumns = (jObject, tableDef) => {
    //console.log("content grid issue: " + JSON.stringify(tableDef));
    return Object.keys(tableDef).map((key, index) => {
      //console.log("here is the " + key);
      if (key !== "searches") {
        return (
          <div>
            <span
              style={{
                marginLeft: "0px",
                color: "grey",
                fontSize: "12px",
                fontWeight: "bold"
              }}
            >
              {tableDef[key].caption}:
            </span>
            <span
              style={{
                wordBreak: "break-word",
                wordWrap: "break-word",
                overflowWrap: "break-word",
                fontSize: "15px",
                paddingLeft: "15px"
              }}
            >
              {this.getDivCellValue(
                tableDef[key].format,
                jObject[key],
                tableDef[key].type
              )}
            </span>
          </div>
        );
      }
    });
  };

  getLoader = () => {
    return (
      <CardContent>
        <CircleProgress indeterminate subtitle="Saving..." />
      </CardContent>
    );
  };

  getHeaderRow = tableDef => {
    return Object.keys(tableDef).map(key => {
      if (key !== "searches" && tableDef[key]) {
        return <th>{tableDef[key].caption}</th>;
      }
    });
  };

  getRows = data => {
    return data.map(rec => {
      return <tr>{this.getColumns(rec, this.props.tableDef)}</tr>;
    });
  };

  getMobileDivs = data => {
    return data.map(rec => {
      return (
        <div
          onClick={() =>
            this.props.handleEdit(rec.key, this.props.tableName, rec)
          }
          style={{
            borderColor: "darkgray",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "10px",
            backgroundColor: "white",
            margin: "5px",
            padding: "5px",
            marginBottom: "15px",
            fontSize: "medium",
            fontWeight: "bold",
            boxShadow: "1px 2px #888888"
          }}
        >
          {this.getDivColumns(rec, this.props.tableDef)}
        </div>
      );
    });
  };

  getTopHeader = () => {
    return (
      <div>
        <Card>
          <CardAreaMain>
            <CardContent>
              <div>
                <h1>BCS HOME</h1>
              </div>
            </CardContent>
            <CardActions></CardActions>
          </CardAreaMain>
        </Card>
      </div>
    );
  };

  getDailyInventory = () => {
    function sum(numbers) {
      //console.log(JSON.stringify(numbers));
      let numSum = _.reduce(
        numbers,
        function(result, current) {
          //console.log("current: " + current + "  result: " + result);
          if (
            current === "" ||
            current === null ||
            current === undefined ||
            current === "NaN"
          ) {
            console.log("Found an NaN===" + current);
            current = 0;
          }
          return result + parseFloat(current);
        },
        0
      );
      //console.log(numSum);
      return numSum.toFixed(2);
    }

    function getDeliveryDate(item) {
      let dDate = moment(item.deliveryDate, "DD-MM-YYYY");
      if (item.createDateTime && item.createDateTime !== "") {
        if (item.createDateTime.includes("/")) {
          dDate = moment(item.createDateTime, "DD/MM/YYYY hh:mm:ss");
        } else {
          dDate = moment(item.createDateTime, "ddd DD-MM-YY h:mm a");
        }
      }

      return dDate.format("DD-MM-YYYY").toString();
    }

    let allOrders = this.props.db["deliveryRequest"];

    let filteredOrders = _.chain(allOrders)
      .filter(item => {
        let createDateTime = getDeliveryDate(item);
        let checkMomDate = moment(createDateTime, "DD-MM-YYYY");
        let sDate = moment(this.state.data.payload.invFromDate, "DD-MM-YYYY");
        let eDate = moment(this.state.data.payload.invToDate, "DD-MM-YYYY");

        if (checkMomDate.isBetween(sDate, eDate, "day", "[]")) {
          if (this.state.data.payload.orderStatus === "ALL") {
            return true;
          } else if (
            this.state.data.payload.orderStatus === "ALL EXCEPT CANCELLED"
          ) {
            return item.status !== "CANCELLED";
          } else {
            return item.status === this.state.data.payload.orderStatus;
          }
        } else {
          return false;
        }
      })
      .map(item => {
        return {
          ...item,
          createDateTime: getDeliveryDate(item)
        };
      })
      .value();
    let prodSales = [];
    for (let i = 0; i < filteredOrders.length; i++) {
      let currOrd = filteredOrders[i];
      let currProds = currOrd.requestedItems;
      for (let j = 0; j < currProds.length; j++) {
        prodSales.push({
          quantity: currProds[j].quantity,
          productNameEnglish: currProds[j].productNameEnglish,
          createDateTime: currOrd.createDateTime,
          name: currOrd.name,
          status: currOrd.status
        });
      }
    }
    let allProductsSalesArray = _.chain(prodSales)
      .groupBy("productNameEnglish")
      .map((value, key) => {
        return {
          productNameEnglish: key,
          totSold: sum(_.pluck(value, "quantity")),
          indOrders: value
        };
      })
      .value();

    let inventoryArray = this.props.db["inventory"];
    let allProductsBuysArray = _.chain(inventoryArray)
      .groupBy("product")
      .map((value, key) => {
        return {
          productNameEnglish: key,
          totPurchased: sum(_.pluck(value, "quantity")),
          indPurchases: value,
          saleInfo: allProductsSalesArray.find(
            item => item.productNameEnglish === key
          )
        };
      })
      .value();
    this.props.onSetUiFlag("allProductsBuysArray", allProductsBuysArray);
  };

  getOverallTotal = dailySaleArray => {
    let totSaleAmt = 0;
    let totPurAmt = 0;
    let totAdminSaleAmt = 0;
    for (let i = 0; i < dailySaleArray.length; i++) {
      totSaleAmt = totSaleAmt + parseFloat(dailySaleArray[i].actualSales);
      totPurAmt =
        totPurAmt +
        (dailySaleArray &&
        dailySaleArray[i].purchaseInfo &&
        dailySaleArray[i].purchaseInfo.retailPurchase
          ? parseFloat(dailySaleArray[i].purchaseInfo.retailPurchase)
          : 0);
      totAdminSaleAmt =
        totAdminSaleAmt +
        (dailySaleArray &&
        dailySaleArray[i].purchaseInfo &&
        dailySaleArray[i].purchaseInfo.smitaSale
          ? parseFloat(dailySaleArray[i].purchaseInfo.smitaSale)
          : 0);
    }
    this.props.onSetUiFlag("totActualSales", totSaleAmt.toFixed(2));
    this.props.onSetUiFlag("totPur", totPurAmt.toFixed(2));
    this.props.onSetUiFlag("totAdminSales", totAdminSaleAmt.toFixed(2));
    this.props.onSetUiFlag("dailySaleArray", dailySaleArray);
    // console.log("total sales" + totSaleAmt.toFixed(2));
    // console.log("total purchase" + totPurAmt.toFixed(2));
    // console.log("total admin sale" + totAdminSaleAmt.toFixed(2));
  };

  getDailySales = () => {
    function sum(numbers) {
      //console.log(JSON.stringify(numbers));
      let numSum = _.reduce(
        numbers,
        function(result, current) {
          //console.log("current: " + current + "  result: " + result);
          if (
            current === "" ||
            current === null ||
            current === undefined ||
            current === "NaN"
          ) {
            //console.log("Found an NaN===" + current);
            current = 0;
          }

          return result + parseFloat(current);
        },
        0
      );
      //console.log(numSum);
      return numSum.toFixed(2);
    }

    function getDeliveryDate(item) {
      let dDate = moment(item.targetDeliveryDate, "ddd DD-MM-YYYY");
      if (
        item.targetDeliveryDate &&
        item.targetDeliveryDate !== undefined &&
        item.targetDeliveryDate !== "" &&
        item.targetDeliveryDate.includes("-")
      ) {
        dDate = moment(item.targetDeliveryDate, "ddd DD-MM-YYYY");
      } else {
        dDate = moment(item.deliveryDate, "DD-MM-YYYY");
      }
      // let dDate = moment(item.deliveryDate, "DD-MM-YYYY");
      // if (item.createDateTime && item.createDateTime !== "") {
      //   if (item.createDateTime.includes("/")) {
      //     dDate = moment(item.createDateTime, "DD/MM/YYYY hh:mm:ss");
      //   } else {
      //     dDate = moment(item.createDateTime, "ddd DD-MM-YY h:mm a");
      //   }
      // }

      return dDate.format("DD-MM-YYYY").toString();
    }

    function getGroupBy(selection) {
      if (selection === "DAILY") {
        return "createDateTime";
      } else if (selection === "WEEKLY") {
        return "week";
      } else if (selection === "MONTHLY") {
        return "month";
      } else {
        return "quarter";
      }
    }

    let allPurchases = this.props.db["purchase"];
    let dailyPurchaseArray = _.chain(allPurchases)
      .filter(item => {
        let createDateTime = item.date;
        if (
          this.state.data.payload.days !== "ALL" &&
          this.state.data.payload.groupBy === "DAILY"
        ) {
          let dDay = moment(createDateTime, "DD-MM-YYYY")
            .format("ddd")
            .toString()
            .toLowerCase();
          // console.log(
          //   dDay + " vs " + this.state.data.payload.days.toLowerCase()
          // );
          return dDay === this.state.data.payload.days.toLowerCase();
        }
        let checkMomDate = moment(createDateTime, "DD-MM-YYYY");

        let sDate = moment(this.state.data.payload.fromDate, "DD-MM-YYYY");
        //console.log(this.state.data.payload.fromDate + "=" + sDate);
        let eDate = moment(this.state.data.payload.toDate, "DD-MM-YYYY");

        if (checkMomDate.isBetween(sDate, eDate, "day", "[]")) {
          return true;
        } else {
          // console.log(
          //   createDateTime +
          //     "(" +
          //     checkMomDate +
          //     ") " +
          //     this.state.data.payload.fromDate +
          //     "(" +
          //     sDate +
          //     ") " +
          //     this.state.data.payload.toDate +
          //     "(" +
          //     eDate +
          //     ")"
          // );
          return false;
        }
      })
      .map(value => {
        return {
          ...value,
          retailPurchase: value.receiptAmount.replace(",", ""),
          wholeSalePurcahse: value.supplierPurchase,
          smitaSale: value.sellAmount,
          createDateTime: value.date,
          week: moment(value.date, "DD-MM-YYYY").week(),
          month: moment(value.date, "DD-MM-YYYY")
            .format("MMM")
            .toString(),
          quarter: moment(value.date, "DD-MM-YYYY").quarter()
        };
      })
      .groupBy(getGroupBy(this.state.data.payload.groupBy))
      .map((value, key) => {
        let refDate = "";

        if (this.state.data.payload.groupBy === "DAILY") {
          refDate = moment(key, "DD-MM-YYYY")
            .format("ddd DD-MM-YYYY")
            .toString();
        } else {
          refDate = key;
        }
        return {
          oDate: refDate,
          momODate: moment(key, "DD-MM-YYYY"),
          retailPurchase: sum(_.pluck(value, "retailPurchase")),
          wholeSalePurcahse: sum(_.pluck(value, "wholeSalePurcahse")),
          smitaSale: sum(_.pluck(value, "smitaSale"))
        };
      })
      .sortBy("momODate")
      .reverse()
      .value();

    let allOrders = this.props.db["deliveryRequest"];
    let dailySaleArray = _.chain(allOrders)
      .filter(item => {
        let createDateTime = getDeliveryDate(item);
        if (
          this.state.data.payload.days !== "ALL" &&
          this.state.data.payload.groupBy === "DAILY"
        ) {
          let dDay = moment(createDateTime, "DD-MM-YYYY")
            .format("ddd")
            .toString()
            .toLowerCase();
          // console.log(
          //   dDay + " vs " + this.state.data.payload.days.toLowerCase()
          // );
          return dDay === this.state.data.payload.days.toLowerCase();
        }
        let checkMomDate = moment(createDateTime, "DD-MM-YYYY");

        let sDate = moment(this.state.data.payload.fromDate, "DD-MM-YYYY");
        //console.log(this.state.data.payload.fromDate + "=" + sDate);
        let eDate = moment(this.state.data.payload.toDate, "DD-MM-YYYY");

        if (checkMomDate.isBetween(sDate, eDate, "day", "[]")) {
          if (this.state.data.payload.orderStatus === "ALL") {
            return true;
          } else if (
            this.state.data.payload.orderStatus === "ALL EXCEPT CANCELLED"
          ) {
            return item.status !== "CANCELLED";
          } else {
            return item.status === this.state.data.payload.orderStatus;
          }
        } else {
          // console.log(
          //   createDateTime +
          //     "(" +
          //     checkMomDate +
          //     ") " +
          //     this.state.data.payload.fromDate +
          //     "(" +
          //     sDate +
          //     ") " +
          //     this.state.data.payload.toDate +
          //     "(" +
          //     eDate +
          //     ")"
          // );
          return false;
        }
      })
      .map(value => {
        return {
          ...value,
          salesTotal:
            value.salesTotal && value.salesTotal > 0
              ? value.salesTotal
              : value.orderTotal,
          createDateTime: getDeliveryDate(value),
          week: moment(getDeliveryDate(value), "DD-MM-YYYY").week(),
          month: moment(getDeliveryDate(value), "DD-MM-YYYY")
            .format("MMM")
            .toString(),
          quarter: moment(getDeliveryDate(value), "DD-MM-YYYY").quarter()
        };
      })
      .groupBy(getGroupBy(this.state.data.payload.groupBy))
      .map((value, key) => {
        let refDate = "";

        if (this.state.data.payload.groupBy === "DAILY") {
          refDate = moment(key, "DD-MM-YYYY")
            .format("ddd DD-MM-YYYY")
            .toString();
        } else {
          refDate = key;
          if (this.state.data.payload.groupBy === "WEEKLY") {
          } else if (this.state.data.payload.groupBy === "MONTHLY") {
          } else if (this.state.data.payload.groupBy === "QUARTLY") {
          }
        }
        //console.log(refDate);
        return {
          oDate: refDate,
          momODate: moment(key, "DD-MM-YYYY"),
          orderTotal: sum(_.pluck(value, "orderTotal")),
          actualSales: sum(_.pluck(value, "salesTotal")),
          purchaseInfo: dailyPurchaseArray.find(item => item.oDate === refDate),
          allRecs: value
        };
      })
      .sortBy("momODate")
      .reverse()
      .value();

    if (this.state.data.payload.groupBy === "MONTHLY") {
      dailySaleArray = dailySaleArray.reverse();
    }

    this.getOverallTotal(dailySaleArray);
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  getProfit = (saleAmt, purchaseAmt) => {
    let sellNumber = parseFloat(saleAmt);
    let purchaseNumber = parseFloat(purchaseAmt);
    let profitNumber = sellNumber - purchaseNumber;
    profitNumber = profitNumber.toFixed(2);
    return profitNumber;
  };

  getSalesReport = () => {
    let dailySaleArray = this.props.ui["dailySaleArray"];
    const getIndOrders = indOrders => {
      if (this.state.data.payload.indOrders === "YES") {
        return indOrders.map(item => {
          return (
            <div
              style={{
                textAlign: "right",
                fontFamily: "Courier",
                fontSize: "8px",
                display: "flex",
                flexDirection: "row"
              }}
              onClick={() => {
                let newObj = { ...item, requestedItems: [], messages: [] };

                alert(JSON.stringify(newObj));
              }}
            >
              <div style={{ width: "20%" }}>{item.name.substring(0, 7)}</div>
              <div style={{ width: "20%" }}>
                {item.createDateTime.substring(0, 5)}
              </div>
              <div style={{ width: "20%" }}>{item.status.substring(0, 7)}</div>
              <div style={{ width: "20%" }}>{item.salesTotal}</div>
              <div style={{ width: "20%" }}>{item.orderTotal}</div>
            </div>
          );
        });
      } else {
      }
    };

    if (dailySaleArray && dailySaleArray.length > 0) {
      if (this.state.data.payload.indOrders) {
        return dailySaleArray.map(item => {
          return (
            <tr>
              <td
                style={{
                  textAlign: "center"
                }}
              >
                {item.oDate}
              </td>
              <td
                style={{
                  textAlign: "center"
                }}
              >
                {item.purchaseInfo &&
                item.purchaseInfo !== undefined &&
                item.purchaseInfo.retailPurchase
                  ? item.purchaseInfo.retailPurchase
                  : ""}
              </td>
              <td
                style={{
                  textAlign: "center"
                }}
              >
                {item.actualSales}
              </td>
              <td
                style={{
                  textAlign: "center"
                }}
              >
                {item.purchaseInfo &&
                item.purchaseInfo !== undefined &&
                item.purchaseInfo.smitaSale
                  ? item.purchaseInfo.smitaSale
                  : ""}
              </td>
              <td
                style={{
                  textAlign: "center"
                }}
              >
                {this.getProfit(
                  item.purchaseInfo &&
                    item.purchaseInfo !== undefined &&
                    item.purchaseInfo.smitaSale
                    ? item.purchaseInfo.smitaSale
                    : "0",
                  item.purchaseInfo &&
                    item.purchaseInfo !== undefined &&
                    item.purchaseInfo.retailPurchase
                    ? item.purchaseInfo.retailPurchase
                    : "0"
                )}
              </td>
              {this.state.data.payload.indOrders === "YES" ? (
                <td>{getIndOrders(item.allRecs)}</td>
              ) : null}
            </tr>
          );
        });
      } else {
        return dailySaleArray.map(item => {
          return (
            <tr>
              <td
                style={{
                  textAlign: "center"
                }}
              >
                {item.oDate}
              </td>
              <td
                style={{
                  textAlign: "center"
                }}
              >
                {item.purchaseInfo &&
                item.purchaseInfo !== undefined &&
                item.purchaseInfo.retailPurchase
                  ? item.purchaseInfo.retailPurchase
                  : ""}
              </td>
              <td
                style={{
                  textAlign: "center"
                }}
              >
                {item.actualSales}
              </td>
              <td
                style={{
                  textAlign: "center"
                }}
              >
                {item.purchaseInfo &&
                item.purchaseInfo !== undefined &&
                item.purchaseInfo.smitaSale
                  ? item.purchaseInfo.smitaSale
                  : ""}
              </td>
              <td
                style={{
                  textAlign: "center"
                }}
              >
                {this.getProfit(
                  item.purchaseInfo &&
                    item.purchaseInfo !== undefined &&
                    item.purchaseInfo.smitaSale
                    ? item.purchaseInfo.smitaSale
                    : "0",
                  item.purchaseInfo &&
                    item.purchaseInfo !== undefined &&
                    item.purchaseInfo.retailPurchase
                    ? item.purchaseInfo.retailPurchase
                    : "0"
                )}
              </td>
            </tr>
          );
        });
      }
    } else {
      return <div></div>;
    }
  };

  getInventoryReport = () => {
    let allProductsBuysArray = this.props.ui["allProductsBuysArray"];

    function getRemainUnits(purUnits, saleInfo) {
      if (saleInfo && saleInfo.totSold) {
        let purQty = parseFloat(purUnits);
        let sellQty = parseFloat(saleInfo.totSold);
        let remUnits = purQty - sellQty;
        return remUnits;
      } else {
        return purUnits;
      }
    }

    const getIndOrders = indOrders => {
      if (this.state.data.payload.indOrders === "YES") {
        return indOrders.map(item => {
          return (
            <div
              style={{
                textAlign: "right",
                fontFamily: "Courier",
                fontSize: "8px",
                display: "flex",
                flexDirection: "row"
              }}
            >
              <div style={{ width: "20%" }}>{item.name.substring(0, 7)}</div>
              <div style={{ width: "20%" }}>
                {item.createDateTime.substring(0, 5)}
              </div>
              <div style={{ width: "20%" }}>{item.status.substring(0, 7)}</div>
              <div style={{ width: "20%" }}>{item.quantity}</div>
            </div>
          );
        });
      } else {
      }
    };

    if (allProductsBuysArray && allProductsBuysArray.length > 0) {
      return allProductsBuysArray.map(item => {
        return (
          <tr>
            <td
              style={{
                textAlign: "center"
              }}
            >
              {item.productNameEnglish}
            </td>
            <td
              style={{
                textAlign: "center"
              }}
            >
              {item.totPurchased}
            </td>
            <td
              style={{
                textAlign: "center"
              }}
            >
              {item.saleInfo && item.saleInfo.totSold
                ? item.saleInfo.totSold
                : ""}
            </td>
            <td
              style={{
                textAlign: "center"
              }}
            >
              {getRemainUnits(item.totPurchased, item.saleInfo)}
            </td>
            {this.state.data.payload.indOrders === "YES" ? (
              <td>
                {getIndOrders(
                  item.saleInfo && item.saleInfo.totSold
                    ? item.saleInfo.indOrders
                    : []
                )}
              </td>
            ) : null}
          </tr>
        );
      });
    } else {
      return <div></div>;
    }
  };

  render() {
    return (
      <div
        style={{
          minHeight: 800
        }}
      >
        <div
          style={{
            margin: "5px",
            border: "1px solid gainsboro",
            padding: "2px"
          }}
        >
          <SelectDropdown
            title={"Order Status"}
            data={[
              { name: "ALL" },
              { name: "ALL EXCEPT CANCELLED" },
              { name: "WITH GROCER FOR PRICE" },
              { name: "DELIVERED" },
              { name: "CANCELLED" }
            ]}
            label={"ORDER STATUS"}
            placeholder={""}
            value={this.state.data.payload.orderStatus}
            stateFieldName={"orderStatus"}
            isPayload={true}
            fieldName={"name"}
            stateHandler={this.stateChangeHandler}
            disabled={false}
          />

          <SelectDropdown
            title={"FREQUENCY"}
            data={[
              { name: "DAILY" },
              { name: "WEEKLY" },
              { name: "MONTHLY" },
              { name: "QUARTERLY" }
            ]}
            label={"FREQUENCY"}
            placeholder={""}
            value={this.state.data.payload.groupBy}
            stateFieldName={"groupBy"}
            isPayload={true}
            fieldName={"name"}
            stateHandler={this.stateChangeHandler}
            disabled={false}
          />
          <DateDropdown
            title={"To Date"}
            //maxDetail={fieldDef.dateMaxDetail === "minute" ? "minute" : ""}
            format={"dd-MM-yyyy"}
            formatOut={"DD-MM-YYYY"}
            onChange={this.stateChangeHandler}
            fieldName={"toDate"}
            value={this.state.data.payload.toDate}
            disabled={false}
          />
          <DateDropdown
            title={"From Date"}
            //maxDetail={fieldDef.dateMaxDetail === "minute" ? "minute" : ""}
            format={"dd-MM-yyyy"}
            formatOut={"DD-MM-YYYY"}
            onChange={this.stateChangeHandler}
            fieldName={"fromDate"}
            value={this.state.data.payload.fromDate}
            disabled={false}
          />

          <SelectDropdown
            title={"DAYS"}
            data={[
              { name: "ALL" },
              { name: "MON" },
              { name: "TUE" },
              { name: "WED" },
              { name: "THU" },
              { name: "FRI" },
              { name: "SAT" },
              { name: "SUN" }
            ]}
            label={"DAYS"}
            placeholder={""}
            value={this.state.data.payload.days}
            stateFieldName={"days"}
            isPayload={true}
            fieldName={"name"}
            stateHandler={this.stateChangeHandler}
            disabled={false}
          />
          <SelectDropdown
            title={"Show Order Breakdown"}
            data={[{ name: "YES" }, { name: "NO" }]}
            label={"VIEW INDIVIDUAL ORDERS"}
            placeholder={""}
            value={this.state.data.payload.indOrders}
            stateFieldName={"indOrders"}
            isPayload={true}
            fieldName={"name"}
            stateHandler={this.stateChangeHandler}
            disabled={false}
          />
          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              color: "blue",
              margin: "5px",
              border: "1px solid blue",
              cursor: "pointer"
            }}
            onClick={() => {
              this.getDailySales();
            }}
          >
            Generate Report
          </div>
        </div>
        <div
          style={{
            display: "flex"
          }}
        ></div>
        <table
          className={
            isMobile
              ? "table table-striped table-sm"
              : "table table-striped table-bordered table-lg"
          }
          style={{ tableLayout: "fixed" }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "center"
                }}
              >
                DATE
              </th>
              <th
                style={{
                  textAlign: "center"
                }}
              >
                PURCHASES
              </th>
              <th
                style={{
                  textAlign: "center"
                }}
              >
                ACTUAL SALE
              </th>
              <th
                style={{
                  textAlign: "center"
                }}
              >
                ADMIN SALE
              </th>
              <th
                style={{
                  textAlign: "center"
                }}
              >
                PROFIT
              </th>
              {this.state.data.payload.indOrders === "YES" ? (
                <th>IND ORDERS</th>
              ) : null}
            </tr>
          </thead>
          <tbody>
            {this.getSalesReport()}
            <tr>
              <td
                style={{
                  textAlign: "right",
                  fontWeight: "bold"
                }}
              >
                TOTAL
              </td>
              <td
                style={{
                  textAlign: "center",
                  fontWeight: "bold"
                }}
              >
                {this.props.ui["totPur"] ? this.props.ui["totPur"] : ""}
              </td>
              <td
                style={{
                  textAlign: "center",
                  fontWeight: "bold"
                }}
              >
                {this.props.ui["totActualSales"]
                  ? this.props.ui["totActualSales"]
                  : ""}
              </td>
              <td
                style={{
                  textAlign: "center",
                  fontWeight: "bold"
                }}
              >
                {this.props.ui["totAdminSales"]
                  ? this.props.ui["totAdminSales"]
                  : ""}
              </td>
              <td
                style={{
                  textAlign: "center",
                  fontWeight: "bold"
                }}
              >
                {this.getProfit(
                  this.props.ui["totAdminSales"]
                    ? this.props.ui["totAdminSales"]
                    : "0",
                  this.props.ui["totPur"] ? this.props.ui["totPur"] : "0"
                )}
              </td>
              {this.state.data.payload.indOrders === "YES" && <td></td>}
            </tr>
          </tbody>
        </table>
        <div
          style={{
            minHeight: "50px"
          }}
        ></div>
        <div
          style={{
            margin: "5px",
            border: "1px solid gainsboro",
            padding: "2px"
          }}
        >
          <DateDropdown
            title={"To Date"}
            //maxDetail={fieldDef.dateMaxDetail === "minute" ? "minute" : ""}
            format={"dd-MM-yyyy"}
            formatOut={"DD-MM-YYYY"}
            onChange={this.stateChangeHandler}
            fieldName={"invToDate"}
            value={this.state.data.payload.invToDate}
            disabled={false}
          />
          <DateDropdown
            title={"From Date"}
            //maxDetail={fieldDef.dateMaxDetail === "minute" ? "minute" : ""}
            format={"dd-MM-yyyy"}
            formatOut={"DD-MM-YYYY"}
            onChange={this.stateChangeHandler}
            fieldName={"invFromDate"}
            value={this.state.data.payload.invFromDate}
            disabled={false}
          />
          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              color: "blue",
              margin: "5px",
              border: "1px solid blue",
              cursor: "pointer"
            }}
            onClick={() => {
              this.getDailyInventory();
            }}
          >
            Generate Report
          </div>
        </div>

        <table
          className={
            isMobile
              ? "table table-striped table-sm"
              : "table table-striped table-bordered table-lg"
          }
          style={{ tableLayout: "fixed" }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "center"
                }}
              >
                PRODUCT NAME
              </th>
              <th
                style={{
                  textAlign: "center"
                }}
              >
                PURCHASED
              </th>
              <th
                style={{
                  textAlign: "center"
                }}
              >
                SOLD
              </th>
              <th
                style={{
                  textAlign: "center"
                }}
              >
                REMAINING
              </th>
              {this.state.data.payload.indOrders === "YES" ? (
                <th>IND ORDERS</th>
              ) : null}
            </tr>
          </thead>
          <tbody>{this.getInventoryReport()}</tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    db: state.db,
    ui: state.ui
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetUiFlag: (flagName, flagVal) => dispatch(setUiFlag(flagName, flagVal))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryGrid);



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/InventoryGrid.jsx